module.exports = __webpack_public_path__ + "static/media/ic-close.abe1da91.svg";